<template>
    <span :class="classes" data-testid="bmv-badge">
        <i v-if="icon" :class="icon" class="bmv-badge-icon"></i>
        <slot />
    </span>
</template>

<script>
const VARIANTS = ['neutral', 'primary', 'success', 'warning', 'danger', 'info']
const SIZES = ['sm', 'md']

export default {
    name: 'BmvBadge',
    props: {
        variant: {
            type: String,
            default: 'neutral',
            validator: (v) => VARIANTS.includes(v)
        },
        size: {
            type: String,
            default: 'md',
            validator: (v) => SIZES.includes(v)
        },
        icon: { type: String, default: '' },
        /** When true, uses a stronger solid background instead of the soft tint. */
        solid: { type: Boolean, default: false }
    },
    computed: {
        classes() {
            return [
                'bmv-badge',
                `bmv-badge--${this.variant}`,
                `bmv-badge--${this.size}`,
                { 'bmv-badge--solid': this.solid }
            ]
        }
    }
}
</script>

<style scoped>
.bmv-badge {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    border-radius: var(--v2-radius-full);
    font-family: var(--v2-font-sans);
    font-weight: var(--v2-font-weight-medium);
    line-height: 1;
    white-space: nowrap;
}

.bmv-badge--sm {
    font-size: 0.6875rem;
    padding: 2px 8px;
}

.bmv-badge--md {
    font-size: var(--v2-text-xs-size);
    padding: 4px 10px;
}

.bmv-badge-icon {
    font-size: 0.9em;
}

/* Soft variants (default) */
.bmv-badge--neutral { background: var(--v2-surface-2); color: var(--v2-text-2); }
.bmv-badge--primary { background: var(--v2-primary-soft); color: var(--v2-primary); }
.bmv-badge--success { background: var(--v2-success-soft); color: var(--v2-success); }
.bmv-badge--warning { background: var(--v2-warning-soft); color: #b45309; }
.bmv-badge--danger { background: var(--v2-danger-soft); color: var(--v2-danger); }
.bmv-badge--info { background: var(--v2-info-soft); color: var(--v2-info); }

/* Solid variants */
.bmv-badge--solid.bmv-badge--neutral { background: var(--v2-text-2); color: #fff; }
.bmv-badge--solid.bmv-badge--primary { background: var(--v2-primary); color: #fff; }
.bmv-badge--solid.bmv-badge--success { background: var(--v2-success); color: #fff; }
.bmv-badge--solid.bmv-badge--warning { background: var(--v2-warning); color: #fff; }
.bmv-badge--solid.bmv-badge--danger { background: var(--v2-danger); color: #fff; }
.bmv-badge--solid.bmv-badge--info { background: var(--v2-info); color: #fff; }
</style>
